module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/administracao/contratos/novo"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com NOME DA UNIDADE"
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataTable($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.categoria_unidade),
      expression: "filtros.categoria_unidade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "categoria_unidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Categoria da Unidade--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Pública (Local)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Município Pactuado (PPI)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Privada")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.tipo),
      expression: "filtros.tipo"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Tipo do Contrato--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Solicitante")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Prestador")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.situacao),
      expression: "filtros.situacao"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtros, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Situação--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Inativo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.getDataTable
    }
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('contratos.id')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'contratos.id' ? ("fa fa-sort-numeric" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("\n                                                Unidade\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "icon-ordenacao",
    on: {
      "click": function($event) {
        _vm.sortByKey('unidades.nome')
      }
    }
  }, [_c('i', {
    class: _vm.filtros.ordem && _vm.filtros.coluna == 'unidades.nome' ? ("fa fa-sort-alpha" + ('-' + _vm.filtros.ordem)) : 'fa fa-sort'
  })])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Categoria")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Data Inicial")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Data Final")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Ação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("categoriaUnidade")(item.categoria)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tipoContrato")(item.tipo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_inicial)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.data_final)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("situacao")(item.situacao)))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/contratos/atualizacao/" + (item.id)),
        "title": "Editar"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-edit",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/contratos/procedimentos/" + (item.id)),
        "title": " Procedimentos do Contrato"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-list",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('router-link', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "tag": "button",
        "to": ("/administracao/contratos/subgrupos/" + (item.id)),
        "title": "Subgrupos do Contrato"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-list-alt",
      staticStyle: {
        "font-size": "12px"
      }
    })])], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Contratos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2c563e98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administracao/contratos/index.vue
// module id = 820
// module chunks = 0